module.exports = __webpack_public_path__ + "img/perfildeefectividad.c875f29e.svg";